import type { IPlaybackScheduleRoot } from '@lucimark/shared/models/player-registration-payload'
import { isScheduleRootAssignment } from '@lucimark/shared/helpers/playbackScheduleMaterializationIdentity'

/**
 * True when `urn` needs no binary download for the pending root (URL widget / HLS metadata).
 */
export function pendingPlaylistUrnReadyWithoutBinary(
  urn: string,
  root: IPlaybackScheduleRoot
): boolean {
  if (!isScheduleRootAssignment(root)) {
    return false
  }
  const widget = root.widgetAssetMetadata?.[urn]
  if (widget != null && typeof widget.urlTemplate === 'string' && widget.urlTemplate !== '') {
    return true
  }
  const hls = root.hlsVideoAssetMetadata?.[urn]
  return hls != null && typeof hls.hlsUrl === 'string' && hls.hlsUrl !== ''
}

/**
 * Fraction of head-frame URNs that are already playable (metadata or IDB hit).
 * `cachedUrns` is the set of URNs with a successful cache row (or just-fetched).
 */
export function pendingPlaylistHeadReadyProgress01(
  headUrns: readonly string[],
  root: IPlaybackScheduleRoot,
  cachedUrns: ReadonlySet<string>
): number {
  if (headUrns.length === 0) {
    // No resolved head yet (time-block miss / empty plan) — not ready; starvation ceiling still applies.
    return 0
  }
  let ready = 0
  for (const urn of headUrns) {
    if (pendingPlaylistUrnReadyWithoutBinary(urn, root) || cachedUrns.has(urn)) {
      ready++
    }
  }
  return ready / headUrns.length
}
